import Vue from 'vue'
import { forEach } from 'lodash'

export default {
  namespaced: true,
  state: {},
  mutations: {
    setCounters(state, counters) {
      forEach(counters, (value, key) => {
        Vue.set(state, key, value)
      })
    }
  },
  actions: {
    /**
     * Запрос счетчиков для лендингов
     * @param {String} fields список полей через запятую
     *
     * manufacturer_count
     * designer_count
     * model_count
     * articles_count
     * cases_count
     * plugin_count
     * russia_manufacturer_count
     * international_company_count
     * des_eng_company_count
     * our_model_count
     * project_smpp_count
     */
    async fetchCounters({ commit }) {
      const fields = [
        'manufacturer_count',
        'designer_count',
        'model_count',
        'articles_count',
        'cases_count',
        'plugin_count',
        'russia_manufacturer_count',
        'international_company_count',
        'des_eng_company_count',
        'our_model_count',
        'project_smpp_count'
      ].join(',')

      return axios
        .get('/web-api-2/counters/' + fields)
        .then(r => r.data)
        .then(counters => {
          commit('setCounters', counters)
        })
        .catch(console.error)
    }
  }
}